import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, functions } from "../../../firebase";
import { notifyError, notifyTopRight } from "../toast/SetToast";

const labels = {
  not_connected: "Not connected",
  pending: "Waiting for authorization",
  ready: "Setting done — Ready to send",
  reconnect_required: "Reconnect required",
};
const AnnualMaskSenderConnectionControls = ({ email, disabled }) => {
  const [connection, setConnection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [unavailable, setUnavailable] = useState(false);
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState(null);
  useEffect(() => onSnapshot(doc(db, "annualMaskSenderConnections", email), (snapshot) => {
    const value = snapshot.exists() ? snapshot.data() : { status: "not_connected" };
    setConnection(value);
    setLoading(false);
    setUnavailable(false);
    if (value.status === "ready" && !value.pendingGeneration) setLink(null);
  }, () => { setLoading(false); setUnavailable(true); }), [email]);
  const connect = async () => {
    setBusy(true);
    try {
      const response = await httpsCallable(functions, "createAnnualMaskSenderConnection")({ email });
      setLink(response.data);
    } catch (error) { notifyError(error.message || "Unable to create the connection link."); }
    finally { setBusy(false); }
  };
  const disconnect = async () => {
    setBusy(true);
    try {
      await httpsCallable(functions, "disconnectAnnualMaskSender")({ email });
      setLink(null);
      notifyTopRight("Mailbox disconnected for all workflows using this address. Connect it again before sending.");
    } catch (error) { notifyError(error.message || "Unable to disconnect the mailbox."); }
    finally { setBusy(false); }
  };
  const status = connection && connection.status;
  return (
    <div style={{ minWidth: 225 }}>
      <div className={`small font-weight-bold mb-2 ${status === "ready" ? "text-success" : "text-muted"}`}>
        {loading ? "Checking connection…" : unavailable ? "Connection status unavailable" : labels[status] || "Not connected"}
      </div>
      <button type="button" className="btn btn-sm btn-outline-primary mr-2 mb-1" disabled={disabled || busy || loading || unavailable} onClick={connect}>
        {busy ? "Working…" : status === "ready" ? "Reconnect email" : "Connect email"}
      </button>
      {status === "ready" && <button type="button" className="btn btn-sm btn-link text-danger p-0" disabled={disabled || busy} onClick={disconnect}>Disconnect mailbox</button>}
      <div className="small text-muted mt-1">Connecting or disconnecting applies to every workflow using this address.</div>
      {link && <div className="border rounded p-2 mt-2 small">
        <a href={link.url} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-primary">Click here to connect email</a>
        <div className="text-muted mt-2">Sign in as {email} and allow sending email. Link expires in 30 minutes.</div>
      </div>}
      {connection && ["failed", "delivery_unknown"].includes(connection.lastDeliveryState) && (
        <div className="small text-danger mt-2">Last email {connection.lastDeliveryState === "delivery_unknown" ? "delivery could not be confirmed. Check Sent mail before retrying." : "failed. Check the mailbox connection and Google API setup."}</div>
      )}
    </div>
  );
};
export default AnnualMaskSenderConnectionControls;
